import classNames from "classnames";
import React from "react";
import { WordleCharacterResult, WordleGuessResult } from "./types";
import { WordleCharacter } from "./WordleCharacter";
import styles from "./WordleGuess.module.scss";

export declare namespace WordleGuess {
  export interface Props {
    word: string;
    result?: WordleGuessResult;
    shake?: boolean;
    colorBorderOnly: boolean;
  }
}

export const WordleGuess = React.memo(function WordleGuessImpl({
  word,
  result,
  shake = false,
  colorBorderOnly,
}: WordleGuess.Props) {
  return (
    <div
      className={classNames("flex gap-2 min-w-0 justify-center", {
        [styles.shake]: shake,
      })}
    >
      {Array(5)
        .fill("")
        .map((_, index) => (
          <WordleCharacter
            key={index}
            char={word[index]}
            result={result?.[index] as WordleCharacterResult | undefined}
            colorBorderOnly={colorBorderOnly}
          />
        ))}
    </div>
  );
});
